import Vue from "vue";
import Router from "vue-router";

const home = () => import("@/pages/home/home");
const seeresult = () => import("@/pages/seeresult/seeresult");
const splash = () => import("@/pages/splash/splash");
const landing = () => import("@/pages/landing/landing");
const chat = () => import("@/pages/chat/chat");
const register = () => import("@/pages/login/register");
const helpvideo = () => import("@/pages/helpvideo/helpvideo");
const about = () => import("@/pages/about/about");
const meeting = () => import("@/pages/meeting/meeting");
const filemeeting = () => import("@/pages/filemeeting/filemeeting");
const favorite = () => import("@/pages/favorite/favorite");
const opinion = () => import("@/pages/opinion/opinion");
const movie = () => import("@/pages/movie/movie");
const contactus = () => import("@/pages/contactus/contactus");
const opinionuser = () => import("@/pages/opinionuser/opinionuser");
const payment = () => import("@/pages/payment/payment");
const categoryLearn = () => import("@/pages/categoryLearn/categoryLearn");
const viewcategory = () => import("@/pages/viewcategory/viewcategory");
const specialtylife = () => import("@/pages/specialtylife/specialtylife");
const editeProfile = () => import("@/pages/editeProfile/editeProfile");
const pageQuestion = () => import("@/pages/pageQuestion/pageQuestion");
const listQuestion = () => import("@/pages/listQuestion/listQuestion");
const stratQuestion = () => import("@/pages/stratQuestion/stratQuestion");
const singleQuestion = () => import("@/pages/singleQuestion/singleQuestion");

Vue.use(Router);

export default new Router({
  mode: "history",
  linkActiveClass: "is-active",
  routes: [
    {
      path: "/",
      name: "splash",
      component: splash,
      meta: {
        title: " ",
        pageTitle: "",
        header: false,
        arrow_forward: false,
        logo: false,
        store: false,
        search: false,
        iconDrawer: false,
      },
    },
    {
      path: "/register",
      name: "register",
      component: register,
      meta: {
        title: " ",
        pageTitle: "",
        header: true,
        arrow_forward: false,
        logo: false,
        store: false,
        search: false,
        iconDrawer: false,
      },
    },
    {
      path: "/home",
      name: "home",
      component: home,
      meta: {
        title: "صفحه اصلی",
        pageTitle: "پیوند عقل و عشق",
        header: true,
        arrow_forward: false,
        logo: false,
        store: false,
        search: true,
        iconDrawer: true,
      },
    },
    {
      path: "/editeProfile",
      name: "editeProfile",
      component: editeProfile,
      meta: {
        title: " ",
        pageTitle: " ",
        header: true,
        arrow_forward: false,
        logo: false,
        store: false,
        search: false,
        iconDrawer: false,
      },
    },
    {
      path: "/favorite",
      name: "favorite",
      component: favorite,
      meta: {
        title: "مورد علاقه های من ",
        pageTitle: "مورد علاقه های من  ",
        header: true,
        arrow_forward: false,
        logo: false,
        store: false,
        search: false,
        iconDrawer: true,
      },
    },
    {
      path: "/chat",
      name: "chat",
      component: chat,
      meta: {
        title: "صندوق پیام ",
        pageTitle: "صندوق پیام",
        header: true,
        arrow_forward: false,
        logo: false,
        store: false,
        search: false,
        iconDrawer: false,
      },
    },
    {
      path: "/about",
      name: "about",
      component: about,
      meta: {
        title: " درباره ما ",
        pageTitle: "درباره ما",
        header: true,
        arrow_forward: false,
        logo: false,
        store: false,
        search: false,
        iconDrawer: false,
      },
    },
    {
      path: "/specialtylife",
      name: "specialtylife",
      component: specialtylife,
      meta: {
        title: "   ",
        pageTitle: " ",
        header: true,
        arrow_forward: false,
        logo: false,
        store: false,
        search: false,
        iconDrawer: true,
      },
    },
    {
      path: "/opinion",
      name: "opinion",
      component: opinion,
      meta: {
        title: "  تجربه کاربران(مهارت زندگی) ",
        pageTitle: "  تجربه کاربران(مهارت زندگی) ",
        header: true,
        arrow_forward: false,
        logo: false,
        store: false,
        search: false,
        iconDrawer: false,
      },
    },
    {
      path: "/opinionuser",
      name: "opinionuser",
      component: opinionuser,
      meta: {
        title: "تجربه کاربران(خودآگاهی) ",
        pageTitle: "تجربه کاربران(خودآگاهی) ",
        header: true,
        arrow_forward: false,
        logo: false,
        store: false,
        search: false,
        iconDrawer: false,
      },
    },
    {
      path: "/meeting",
      name: "meeting",
      component: meeting,
      meta: {
        title: " ",
        pageTitle: "",
        header: true,
        arrow_forward: false,
        logo: false,
        store: false,
        search: false,
        iconDrawer: true,
      },
    },
    {
      path: "/filemeeting",
      name: "filemeeting",
      component: filemeeting,
      meta: {
        title: "",
        pageTitle: "",
        header: true,
        arrow_forward: false,
        logo: false,
        store: false,
        search: false,
        iconDrawer: false,
      },
    },
    {
      path: "/movie",
      name: "movie",
      component: movie,
      meta: {
        title: "",
        pageTitle: "",
        header: true,
        arrow_forward: false,
        logo: false,
        store: false,
        search: false,
        iconDrawer: false,
      },
    },
    {
      path: "/payment",
      name: "payment",
      component: payment,
      meta: {
        title: "خرید محتوا آموزشی",
        pageTitle: " خرید محتوا آموزشی",
        header: true,
        arrow_forward: false,
        logo: false,
        store: false,
        search: false,
        iconDrawer: false,
      },
    },
    {
      path: "/viewcategory",
      name: "viewcategory",
      component: viewcategory,
      meta: {
        title: "",
        pageTitle: "",
        header: true,
        arrow_forward: false,
        logo: false,
        store: false,
        search: false,
        iconDrawer: true,
      },
    },
    {
      path: "/categoryLearn",
      name: "categoryLearn",
      component: categoryLearn,
      meta: {
        title: " خودآگاهی ",
        pageTitle: "خودآگاهی",
        header: true,
        arrow_forward: false,
        logo: false,
        store: false,
        search: false,
        iconDrawer: true,
      },
    },
    {
      path: "/contactus",
      name: "contactus",
      component: contactus,
      meta: {
        title: " ارتباط با ما ",
        pageTitle: "ارتباط با ما",
        header: true,
        arrow_forward: false,
        logo: false,
        store: false,
        search: false,
        iconDrawer: false,
      },
    },
    {
      path: "/landing",
      name: "landing",
      component: landing,
      meta: {
        title: "",
        pageTitle: "",
        header: false,
        arrow_forward: false,
        logo: false,
        store: false,
        search: false,
        iconDrawer: false,
      },
    },
    {
      path: "/helpvideo",
      name: "helpvideo",
      component: helpvideo,
      meta: {
        title: "راهنمای برنامه",
        pageTitle: "راهنمای برنامه",
        header: true,
        arrow_forward: false,
        logo: false,
        store: false,
        search: false,
        iconDrawer: false,
      },
    },
    {
      path: "/pageQuestion",
      name: "pageQuestion",
      component: pageQuestion,
      meta: {
        title: " تست هوش و روانشناسی",
        pageTitle: " تست هوش و روانشناسی",
        header: true,
        arrow_forward: false,
        logo: false,
        store: false,
        search: false,
        iconDrawer: true,
      },
    },
    {
      path: "/listQuestion",
      name: "listQuestion",
      component: listQuestion,
      meta: {
        title: "فهرست تست ها ",
        pageTitle: "فهرست تست ها",
        header: true,
        arrow_forward: false,
        logo: false,
        store: false,
        search: false,
        iconDrawer: true,
      },
    },
    {
      path: "/stratQuestion",
      name: "stratQuestion",
      component: stratQuestion,
      meta: {
        title: " ",
        pageTitle: " ",
        header: true,
        arrow_forward: false,
        logo: false,
        store: false,
        search: false,
        iconDrawer: true,
      },
    },
    {
      path: "/singleQuestion",
      name: "singleQuestion",
      component: singleQuestion,
      meta: {
        title: " ",
        pageTitle: " ",
        header: true,
        arrow_forward: false,
        logo: false,
        store: false,
        search: false,
        iconDrawer: true,
      },
    },
    {
      path: "/seeresult",
      name: "seeresult",
      component: seeresult,
      meta: {
        title: "",
        pageTitle: "",
        header: true,
        arrow_forward: false,
        logo: false,
        store: false,
        search: false,
        iconDrawer: false,
      },
    },
  ],
});
